import React, { useState } from 'react';
import { HiOutlineShieldCheck } from 'react-icons/hi2';

// Icon for an app we ship no art for, resolved from its verified host. Google's
// favicon service sidesteps the hotlink protection on many sites' /favicon.ico.
const AppFavicon = ({ host, className = 'w-8 h-8' }) => {
  const [failed, setFailed] = useState(false);
  if (!host || failed) {
    return <HiOutlineShieldCheck className={`${className} text-blue-500 dark:text-blue-400`} role="img" aria-label={host || 'Application'} />;
  }
  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${host}&sz=64`}
      alt=""
      className={`${className} rounded-md object-contain`}
      onError={() => setFailed(true)}
    />
  );
};

export default AppFavicon;
